import isBatchesEnabled from 'registry/IsBatchesEnabled';

export default function getRegistrySchemasTitle(): string {
  return isBatchesEnabled() ? 'Entity / batch schemas' : 'Entity schemas';
}
